define('modules/page_generator/models/page',['require','exports','module','backbone','env'],function(require, exports, module){
	"use strict";
	var Backbone = require("backbone"),
			config = require("env");

	module.exports = Backbone.Model.extend({
		urlRoot: function(){
			return [config.apiHost, "pages"].join("/");
		}
	});
});
